require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/es6.array.species.js
// module id = 780
// module chunks = 0